import React from 'react';
import { History } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import useWorkbenchHistoryBadge from '@/pages/ipe/workbench/hooks/useWorkbenchHistoryBadge';

export default function WorkbenchHistoryButton({
  scopeId,
  onClick,
  className = 'img2img-studio__history-btn',
  active = false,
  iconSize = 15,
  label,
  // 兼容旧 prop：角标已改为本地事件，不再远程轮询
  pauseBadgePoll: _pauseBadgePoll = false,
}) {
  const { t } = useTranslation('workbench');
  const buttonLabel = !label || label === '历史记录' ? t('studioChrome.history') : label;
  // count 仅读当前 personal/team 桶；切换 workspaceMode 立刻换桶
  const { count } = useWorkbenchHistoryBadge(scopeId);
  const ariaLabel = count > 0
    ? t('studioChrome.historyPending', { count })
    : buttonLabel;

  return (
    <button
      type="button"
      className={`${className} workbench-history-btn${active ? ' is-active' : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <History size={iconSize} aria-hidden="true" />
      {buttonLabel}
      {count > 0 ? (
        <span className="workbench-history-badge" aria-hidden="true">
          {count > 99 ? '99+' : count}
        </span>
      ) : null}
    </button>
  );
}
